import { render } from "./search-filter-salary.vue?vue&type=template&id=c8fe0ad2"
import script from "./search-filter-salary.vue?vue&type=script&lang=js"
export * from "./search-filter-salary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__